import { useTranslation } from "react-i18next";
const FilterButton = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "filters" });
  return (
    <button className="filter-btn btn-rounded" onClick={props.enableFilter} aria-expanded={props.isExpanded}>
      {props.buttonText} <span className="sr-only"> {t("filter")}</span>
      {props.getFilterType.indexOf("any") === -1 && props.getFilterType.length > 0 && (
        <span class="active-filters-count">
          {props.getFilterType.length}
          <span className="sr-only">{t("selected")}</span>
        </span>
      )}
      <i class="btb bt-angle-down"></i>
    </button>
  );
};

export default FilterButton;
